import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import HealthTags from 'src/components/healthTags';
import { textSmall } from 'styles-js/mixins/typography';
import Spacer, { Size } from 'src/components/spacer';
export default function PostTags() {
  const tags = useSelector(({
    pages
  }) => pages.singlePost.post.entities);
  const currentUser = useSelector(({
    context
  }) => context.currentUser);
  if (!tags?.length) return null;
  return <>
      <Title data-sentry-element="Title" data-sentry-source-file="postTags.tsx">
        {!currentUser ? i18n.t('Read more about...') : i18n.t('Related Tags')}
      </Title>
      <HealthTags tags={tags} data-sentry-element="HealthTags" data-sentry-source-file="postTags.tsx" />
      <Spacer screenS={Size.L} size={Size.XL} data-sentry-element="Spacer" data-sentry-source-file="postTags.tsx" />
    </>;
}
const Title = styled.div`
  ${textSmall}
  color: ${({
  theme
}) => theme.colorTextLight};
  font-weight: ${({
  theme
}) => theme.fontWeightBold};
  margin-bottom: 10px;
`;